import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper, TextField,
} from "@mui/material";
import { Pagination, Select, SelectItem, Skeleton, Spinner } from "@heroui/react";
import LeadHistoryModal from "../PopupModals/LeadHistoryModal";
import { TableEditIcon } from "../../utils/svgIcons";
import { AiTwotoneDelete } from "react-icons/ai";

export const pageLimitsNumber = [
  { value: "10", label: "10", key: "10", },
  { value: "20", label: "20", key: "20" },
  { value: "50", label: "50", key: "50" },
  { value: "100", label: "100", key: "100" },
  { value: "150", label: "150", key: "150" },
];

const formatDate = (isoString) => {
  if (!isoString) return "-";

  const date = new Date(isoString);

  // Format date manually as DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  // Format time using toLocaleTimeString
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });

  return `${formattedDate}, ${formattedTime}`;
};


// Collapsible Row Component
function Row({ row, columns, index, currentPage, pageLimit, HandleLeadDetails, leadType, handleGetLeadDetails, isleadAction, handleEdit, handleDelete }) {
  const indexValue = (currentPage - 1) * pageLimit + (index + 1);

  const [sourceType] = useState(
    {
      1: 'Landing Page', 2: 'Fresh Work', 3: 'FTBV', 4: 'Inquiry',
      5: 'Whatsapp', 6: 'New Fresh Marketer', 7: 'BotBuz', 8: 'Excel', 9: 'Vidyut Freshmarketer', 10: 'RENAV-FORM-INQUIRY',
      11: 'TVS-LP', 12: 'RENAV-WHATSAPP', 13: 'HP-LP', 14: 'VIDA-LP', 15: 'CL', 16: 'TP', 17: 'DS', 18: 'RENAV-MISSED-CALL',
      19: 'RENAV-WHATSAPP-547', 20: 'RENAV-WHATSAPP-348', 21: 'RENAV-WHATSAPP-563', 22: 'RENAV-WHATSAPP-507',
      23: 'RENAV-WHATSAPP-742', 24: 'DIRECT-EXCEL', 25: "DIALSHREE-INBOUND-LEADS", 26: "OLA-EXCEL-IMPORT", 27: "GOOGLE-ADS", 28: "AMPERE-EXCEL-IMPORT", 29: "RETARGETTING", 30: "Listing Page"
    }
  )

  return (
    <>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }} className="border-none removed-border-bottom">

        {(isleadAction && (isleadAction.edit || isleadAction.delete)) && (
          <TableCell className=" !flex">
            {(isleadAction && isleadAction.edit) && (
              <IconButton aria-label="expand row" size="small" onClick={() => handleEdit(row._id)} >
                <TableEditIcon size={25} />
              </IconButton>
            )}

            {(isleadAction && isleadAction.delete) && (
              <IconButton aria-label="expand row" size="small" onClick={() => handleDelete(row._id)} >
                <AiTwotoneDelete size={25} />
              </IconButton>
            )}
          </TableCell>
        )}



        <TableCell className="!py-[12px]">
          <p className="text-black text-medium font-bold">{indexValue}</p>
        </TableCell>

        {/* Render Dynamic Columns */}
        {columns.map((col) => (
          <TableCell key={col.uid} align="left" className="border-none !py-[12px] whitespace-nowrap">
            {(() => {
              const value = row[col.uid];

              switch (col.uid) {
                case "createdAt":
                case "updatedAt":
                  return formatDate(value);

                case "flag":
                  const statusLabels = ["Inactive", "active", "delete", "deleted by user", "draft"];
                  const statusColors = {
                    "Inactive": "bg-gray-200",
                    "active": "bg-accepted",
                    "delete": "bg-danger",
                    "deleted by user": "bg-danger",
                    "draft": "bg-warning",
                  };
                  const status = statusLabels[Number(value)] || "N/A";
                  const colorClass = statusColors[status] || "bg-gray-200";

                  return (
                    <div className={`inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3 capitalize ${colorClass}`}>
                      {status}
                    </div>
                  );

                case "source":
                  return (
                    <div className="bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3">
                      {sourceType[value] || value.label}
                    </div>
                  );

                case "brand":
                  return (
                    <div className="bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3">
                      {value}
                    </div>
                  );

                case "subSource":
                  return (
                    <div className="bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3">
                      {typeof value === 'object' && value !== null ? (value.label || '') : (value ?? '')}
                    </div>
                  );

                case "ola_verification":
                  return (
                    <>
                      <div className={`${value === 1 ? "!bg-accepted" : value === 2 ? "bg-danger" : value === 3 ? "bg-danger" : value === 4 ? "bg-blue-500" : value === 7 ? "bg-yellow-600" : value === 8 ? "bg-purple-600" : value === 5 ? "bg-orange-800" : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block`}>
                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Un Processed" : value === 4 ? "Duplicate" : value === 7 ? "Store(B)" : value === 8 ? "Store(A)" : value === 5 ? "Not Eligible" : "N/A"}
                      </div>
                    </>
                  );

                case "tvs_verification":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "tvs_history")}
                      className={`${value === 1 ? "bg-accepted text-white" : value === 2 ? "bg-danger text-white" : value === 3 ? "bg-info text-white" : value === 4 ? "bg-blue-500 text-white" : value === 5 ? "bg-danger text-white" : value === 6 ? "bg-black text-white" : "bg-white !text-black"} 
                    py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                    >
                      <>
                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Un Processed" : value === 4 ? "Duplicate" : value === 5 ? "Dealer Not Found" : value === 6 ? "Old Leads" : "N/A"}
                      </>
                    </div>
                  );

                case "pushed_to_tvs":
                  return (
                    <div
                      className={`${value === 1 ? "bg-accepted text-white" : value === 2 ? "bg-yellow-300 !text-black" : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block`}
                    >
                      {value === 1 ? "Completed" : value === 2 ? "Pending" : "N/A"}
                    </div>
                  );

                case "revolt_Lead_Process":
                  return (
                    <>
                      <div
                        onClick={() => HandleLeadDetails(row._id, "revolt_history")}
                        className={`${value === 1 ? "!bg-accepted" : value === 0 ? "bg-yellow-300 !text-black" : value === 2 ? 'bg-blue-500 text-white' : value === 3 ? "bg-danger" : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        <>
                          {value === 0 ? 'Pending' : value === 1 ? 'Completed' : value === 2 ? 'Duplicate' : value === 3 ? 'Failed' : 'N/A'}
                        </>
                      </div>
                    </>
                  );

                case "pushed_to_revolt":
                  return (
                    <div
                      className={`${value === 1 ? "bg-accepted" : value === 2 ? "bg-danger" : "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md text-white inline-block`}
                    >
                      <>
                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : "N/A"}
                      </>
                    </div>
                  );

                case "pushed_to_ampere":
                  return (
                    <>
                      <div
                        onClick={() => HandleLeadDetails(row._id, "ampere_history")}
                        className={`${value === 1 ? "bg-accepted" : value === 2 ? "bg-danger" : value === 3 ? 'bg-blue-500 text-white' : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        <>
                          {value === 1 ? "Success" : value === 2 ? "UnSuccess" : value === 3 ? "Duplicate" : "N/A"}
                        </>
                      </div>
                    </>
                  );

                case "simple_verification":
                case "simple_status":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "simple_history")}
                      className={`${value === 1 ? "bg-accepted text-white" : value === 2 ? "bg-danger text-white" : value === 3 ? "bg-yellow-300 !text-black" : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                    >
                      {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Pending" : "N/A"}
                    </div>
                  );

                case "pushed_to_simple":
                  return (
                    <div
                      className={`${value === 1 ? "bg-accepted text-white" : value === 2 ? "bg-yellow-300 !text-black" : value === 3 ? "bg-danger text-white" : "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block`}
                    >
                      {value === 1 ? "Success" : value === 2 ? "Pending" : value === 3 ? "Failed" : "N/A"}
                    </div>
                  );

                case "simple_history": {
                  const historyList = Array.isArray(value) ? value : (value && typeof value === 'object' ? [value] : []);
                  if (!historyList || historyList.length === 0) {
                    return <span className="text-gray-400 font-medium">-</span>;
                  }
                  const latest = historyList[historyList.length - 1];
                  const latestStatus = latest?.status || (latest?.simple_verification === 1 ? "Accepted" : latest?.simple_verification === 2 ? "Rejected" : "View");
                  const latestMsg = typeof latest?.message === "object" ? (latest?.message?.message || latest?.message?.error || JSON.stringify(latest.message)) : (latest?.message || "");
                  const isAccepted = latestStatus === "Accepted" || latestStatus === "Success" || latestStatus === 1;
                  const isRejected = latestStatus === "Rejected" || latestStatus === "Failed" || latestStatus === 2;

                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "simple_history")}
                      className="inline-flex items-center gap-1.5 cursor-pointer max-w-[280px] group"
                      title={`${latestStatus}: ${latestMsg}\nClick to view full history`}
                    >
                      <span
                        className={`py-0.5 px-2 text-xs rounded-global font-semibold text-white shadow-sm shrink-0 ${
                          isAccepted
                            ? "bg-accepted"
                            : isRejected
                            ? "bg-danger"
                            : "bg-gray-500"
                        }`}
                      >
                        {String(latestStatus)}
                      </span>
                      {latestMsg && (
                        <span className="text-xs text-gray-700 truncate group-hover:underline">
                          {latestMsg}
                        </span>
                      )}
                    </div>
                  );
                }

                default: {
                  if (value === null || value === undefined || value === "") return "-";
                  if (Array.isArray(value)) {
                    if (value.length === 0) return "-";
                    const first = value[0];
                    if (typeof first === "object" && first !== null) {
                      const latest = value[value.length - 1];
                      const statusText = latest?.status || latest?.message || `View (${value.length})`;
                      return (
                        <span
                          className="cursor-pointer text-primary hover:underline text-xs"
                          onClick={() => HandleLeadDetails && HandleLeadDetails(row._id, col.uid)}
                        >
                          {typeof statusText === "object" ? JSON.stringify(statusText) : String(statusText)}
                        </span>
                      );
                    }
                    return value.join(", ");
                  }
                  if (typeof value === "object") {
                    return JSON.stringify(value);
                  }
                  return String(value);
                }
              }
            })()}
          </TableCell>
        ))}
      </TableRow >
    </>
  );
}

function TableData({ allLeadsData, isleadAction, columns, selectedColumns, setPageLimit, pageLimit = '10', getAllLeads, leadType, getleadDetails, debouncedSearch, user, handleEdit, handleDelete }) {

  const [leadData, setLeadData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [leadDetails, setLeadDetails] = useState([]);
  const [isfetching, setIsfetching] = useState(false);
  const [openLeadView, setOpenLeadView] = useState(false);
  const [queries, setQueries] = useState({
    search: '',
    limit: pageLimit,
    page: 1,
    totalDocs: 0,
    totalPages: 0
  })

  const isFirstRender = useRef(true);

  // handel pageLimit
  const handlePageChange = (selectedPage) => {
    setQueries((prev) => {
      if (prev.page !== selectedPage) {
        return { ...prev, page: selectedPage };
      }
      return prev; // Prevent unnecessary updates
    });
    setCurrentPage(selectedPage);

    // Explicitly fetch leads if switching back to page 1
    if (selectedPage === 1) {
      let apiParams = leadType === "TpLeads" ? { page: 1, limit: pageLimit, search: debouncedSearch, company: 'TP', admin: { id: user?._id, type: user?.type } } : { page: 1, limit: pageLimit, search: debouncedSearch };
      getAllLeads(apiParams);
    }
  };

  // Fetch Leads on Page or Limit Change
  useEffect(() => {
    if (!isFirstRender.current) {
      let apiParams = leadType === "TpLeads" ? { page: queries.page, limit: queries.limit, search: debouncedSearch, company: 'TP', admin: { id: user?._id, type: user?.type } } : { page: queries.page, limit: queries.limit, search: debouncedSearch };
      getAllLeads(apiParams);
    } else {
      isFirstRender.current = false; // Prevent first render API call
    }
  }, [queries.page, queries.limit]); // Ensure it runs on page and limit change


  useEffect(() => {
    if (allLeadsData?.totalPages) {
      setQueries((prev) => ({ ...prev, totalPages: allLeadsData.totalPages }));
    }
  }, [allLeadsData]);

  useEffect(() => {
    if (allLeadsData?.page !== queries.page) {
      setCurrentPage(allLeadsData.page || 1);
    }
  }, [allLeadsData]);

  // const filteredColumns = columns.filter((col) => selectedColumns.includes(col.uid) && col.uid !== "_id");
  const filteredColumns = columns.filter((col) => selectedColumns.includes(col.uid) && !["_id", "flag", "actions"].includes(col.uid));
  const currentRows = allLeadsData?.docs || [];
  const totalPages = allLeadsData?.totalPages || 1;

  // Page Limit Change
  const onPageClick = (page, limit) => {
    setCurrentPage(page); // Ensure the UI updates immediately
    setQueries((prev) => ({ ...prev, page, limit }));

    let apiParams = leadType === "TpLeads" ? { page: page, limit: limit, search: debouncedSearch, company: 'TP', admin: { id: user?._id, type: user?.type } } : { page: page, limit: limit, search: debouncedSearch };
    getAllLeads(apiParams);
  };

  // Handle Lead History
  const HandleLeadDetails = (id, tag) => {
    setLeadData(currentRows.find((lead) => lead._id === id)?.[tag] || []);
    setModalTitle(
      tag.replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\bHistory\b/gi, "") // Remove the word "History" (case insensitive)
        .trim() // Remove any extra spaces
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    );
    setIsModalOpen(true);
  };

  // Handle get Lead Details
  const handleGetLeadDetails = (id) => {
    setOpenLeadView(true);
    setIsfetching(true);
    // getleadDetails(id).then((res) => {
    //   setLeadDetails(res.data.result);
    //   setTimeout(() => {
    //     setIsfetching(false);
    //   }, 2000);
    // });
  }

  return (
    <>
      {(currentRows && currentRows.length > 0) ? (
        <>
          <Box className="shadow-none px-4 py-6 rounded-outSideglobal w-full overflow-x-auto default-scrollbar h-full overflow-hidden">
            <TableContainer component={Paper} className="p-5 roundedOutSideglobal overflow-x-auto overflow-y-auto h-[calc(100%-68px)] shadow-global default-scrollbar !bg-[rgb(229_243_251_/_var(--tw-bg-opacity,_1))]">
              {selectedColumns.length > 0 ? (
                <Table aria-label="collapsible table">
                  <TableHead
                    // className="rounded-outSideglobal shadow-global table-shadow-specific"
                    className="rounded-outSideglobal shadow-global table-shadow-specific !sticky top-0 !bg-[rgb(229_243_251_/_var(--tw-bg-opacity,_1))] z-10"
                  >
                    <TableRow className="border-none removed-border">
                      {(leadType !== "SourceCombination" && leadType !== "TpLeads") && (
                        <TableCell align="left" className="border-none removed-border flex" />
                      )}
                      <TableCell key={"No"} align="left" className="border-none removed-border" >No</TableCell>
                      {filteredColumns.map((col) => (
                        <TableCell key={col.uid} align="left" className="border-none removed-border whitespace-nowrap">
                          {col.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody className="border-none removed-border w-full text-center">
                    {currentRows?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={filteredColumns.length + 2} align="center">
                          No rows to display.
                        </TableCell>
                      </TableRow>
                    ) : (
                      currentRows?.map((row, index) => (
                        <Row handleEdit={handleEdit} handleDelete={handleDelete} isleadAction={isleadAction} key={row.id} row={row} columns={filteredColumns} index={index} currentPage={currentPage} HandleLeadDetails={HandleLeadDetails} pageLimit={parseInt(pageLimit, 10)} leadType={leadType} handleGetLeadDetails={handleGetLeadDetails} />
                      ))
                    )}
                  </TableBody>
                </Table>
              ) : (<div className="text-center text-2xl font-bold h-full flex items-center justify-center">No columns selected</div>)}
            </TableContainer>

            {/* Pagination Controls */}
            {selectedColumns.length > 0 && (
              <div className="pagination-wrapper w-full flex items-center justify-between mt-4">
                <div className="flex items-center justify-center w-[200px] gap-1">
                  <p>Show</p>
                  <Select
                    className="max-w-[90px] bg-black!  border-gray-100 rounded-[13px]"
                    // items={pageLimitsNumber}
                    placeholder="Page size"
                    color='custom-bg'
                    variant="bordered"
                    defaultSelectedKeys={['10']}
                    selectedKeys={[pageLimit]}
                    onSelectionChange={(keys) => {
                      const newLimit = Array.from(keys)[0]; // Hero UI returns a Set, so convert it to array
                      setPageLimit(newLimit);
                      setCurrentPage(1);
                      onPageClick(1, newLimit);
                    }}
                  >
                    {pageLimitsNumber.map((item) => (
                      <SelectItem key={item.key} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </Select>
                  <p>Entries</p>
                </div>
                <Box display="flex w-full" justifyContent="center" mt={2}>
                  <Pagination
                    key={currentPage}
                    color='success'
                    classNames={{
                      wrapper: "",
                      item: "",
                      cursor:
                        "bg-success text-white",
                    }}
                    size={(currentPage > 100 || currentPage > '100') ? 'lg' : 'md'}
                    isCompact
                    showControls
                    total={totalPages}
                    page={currentPage}
                    onChange={(page) => handlePageChange(page)}
                  />
                </Box>
              </div>
            )}
          </Box>
          <LeadHistoryModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            leadHistory={leadData}
            title={modalTitle}
          />
        </>
      ) : (
        <>
          <div className="text-center h-full flex items-center justify-center text-3xl font-bold" >No records found.</div>
        </>
      )
      }
    </>
  )
}

export default TableData;
